import { Heading } from './ui/Heading'
import { Text } from './ui/Text'
import { cn } from '@lib/cn'
import { FC } from 'react'

type Props = {
  preTitle?: string
  title?: string
  description?: string
  headingTag?: 'h1' | 'h2'
  className?: string
}

const TextBlock: FC<Props> = ({
  preTitle,
  title,
  description,
  children,
  headingTag = 'h1',
  className,
}) => {
  return (
    <section
      className={cn(
        'mx-auto mb-5 max-w-[680px] overflow-hidden break-words px-5 text-center',
        className,
      )}
    >
      {preTitle && (
        <Heading variant="very-small-title" as="div" className="mb-5 text-rolexShade-700">
          {preTitle}
        </Heading>
      )}
      {title && (
        <Heading variant="large" as={headingTag} className="mb-5 whitespace-pre-line">
          {title}
        </Heading>
      )}
      {description && (
        <Text variant="regular" className="mx-auto mb-0 max-w-[870px]">
          {description}
        </Text>
      )}
      {children}
    </section>
  )
}

export default TextBlock
